import React, { useEffect, useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faSortUp, faSortDown, faEllipsisV, faX, faChevronDown, faPlus, faPlusCircle, faSearch,    } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import {Loader, Spinner} from '../Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../Messages/Messages';
import Select from 'react-select';
import { FaChevronDown } from 'react-icons/fa';
import Search from '../Components/Search';
import { decryptData } from '../../utils/storageCrypto';

const AllItems = () => {
  const  [Items , setItems] = useState ([])
  const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate()
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  const [isLoading, setIsLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [errorMessages, setErrorMessages] = useState([]);
  const [showOpen, setShowOpen] = useState(false);
  const [showExportItemPopup, setshowExportItemPopup] = useState(false);
  const [showAddNewPopup, setShowAddNewPopup] =useState(false);
  const [selectedOption, setSelectedOption] = useState(null)
  const [selectedFormat, setSelectedFormat] = useState('');

  const [selectedItems, setSelectedItems] = useState([]); // Add this state
  const [selectAll, setSelectAll] = useState(false); // Add this state
  const [retryFunction, setRetryFunction] = useState(null);
  const [selectedHeadersForExport, setSelectedHeadersForExport] = useState([]); // State for selected headers
const [setHeaders, setSetHeaders] = useState([]);
const [roleId, setRoleId] = useState(null);
const [filteredItems, setFilteredItems] = useState(Items);
  const [Type , setType ] = useState('');
const [searchdropDown, setSearchDropDown] = useState(false);
  const searchTypes  = ['Item Name',  'Vendors',  'Item Category', 'Item Sub Category', 'Item Group'];
  const dropdownRef = useRef(null);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // You can make this configurable

  const dropdownOptions = [
    { value: 'product_name', label: 'Product Name' },
    { value: 'SKU', label: 'SKU' },
    { value: 'HSN_Code', label: 'HSN Code' },
    { value: 'selling_price', label: 'Selling Price' },
    { value: 'cost_price', label: 'Cost Price' },
    { value: 'tax_preference', label: 'Tax Preference' },
    { value: 'specifications', label: 'Specifications' },
    { value: 'GST', label: 'GST' },
    { value: 'IGST', label: 'IGST' },
  ];

  const [persistedSearchQuery, setPersistedSearchQuery] = useState('');
  const [persistedSearchType, setPersistedSearchType] = useState('');
  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES
  const RETRY_LIMIT = 3; // Maximum number of retries
  const [retryCount, setRetryCount] = useState(0); // Track retry attempts
  const [searchChips, setSearchChips] = useState([]);

  const sortArray = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  
    // Function to get nested value using key
    const getNestedValue = (item, key) => {
      return key.split('.').reduce((value, keyPart) => {
        return value ? value[keyPart] : undefined;
      }, item);
    };
  
    const sortedArray = [...Items].sort((a, b) => {
      const aValue = getNestedValue(a, key) || ''; // Treat undefined as empty string
      const bValue = getNestedValue(b, key) || ''; // Treat undefined as empty string
  
      // Convert to string for comparison and handle case insensitivity
      const aString = aValue.toString().toLowerCase();
      const bString = bValue.toString().toLowerCase();
  
      if (aString < bString) {
        return direction === 'ascending' ? -1 : 1;
      }
      if (aString > bString) {
        return direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
  
    setItems(sortedArray);
    // Reset to first page when sorting
    setCurrentPage(1);
  };
  

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? faSortUp : faSortDown;
    }
    return null;
  };
  


 useEffect(() => {
  const savedSearchChips = JSON.parse(sessionStorage.getItem('itemsSearchChips')) || [];
  setSearchChips(savedSearchChips);

  const savedSearchQuery = sessionStorage.getItem('itemsSearchQuery');
  const savedSearchType = sessionStorage.getItem('itemsSearchType');

  if (savedSearchQuery && savedSearchType) {
    setPersistedSearchQuery(savedSearchQuery);
    setPersistedSearchType(savedSearchType);
    setType(savedSearchType);
  }

  fetchRoleId();
  fetchItems();
}, []);



  useEffect(() => {
    if (Items.length > 0) {
      // Apply saved search if available
      if (persistedSearchQuery && persistedSearchType) {
        handleSearch(persistedSearchQuery, persistedSearchType);
      } else {
        setFilteredItems(Items);
      }
    }
  }, [Items]);

  

  const handleSearch = (query, type) => {
  sessionStorage.setItem('itemsSearchQuery', query || '');
  sessionStorage.setItem('itemsSearchType', type || 'Item Name');

  setPersistedSearchQuery(query);
  setPersistedSearchType(type);
  setType(type);

 if (!query || query.trim() === '') {
    setFilteredItems(Items);
    setCurrentPage(1);
    return;
  }

  // Only filter, don't add chip here (chip added on Enter or history click)
  const lowercaseQuery = (query || '').toLowerCase();
  const filtered = Items.filter((item) => {
    switch (type) {
      case 'Item Name':
        return item?.product_name?.toLowerCase().includes(lowercaseQuery);
      case 'Vendors':
        return item?.vendor_id?.name?.toLowerCase().includes(lowercaseQuery);
      case 'Item Category':
        return item?.product_category_id?.product_category_name?.toLowerCase().includes(lowercaseQuery);
      case 'Item Sub Category':
        return item?.product_sub_category_id?.product_sub_category_name?.toLowerCase().includes(lowercaseQuery);
      case 'Item Group':
        return item?.product_group_id?.product_group_name?.toLowerCase().includes(lowercaseQuery);
      default:
        return false;
    }
  });

  setFilteredItems(filtered);
  setCurrentPage(1);
};

const handleRemoveSearchChip = (chipToRemove) => {
  const updatedChips = searchChips.filter(
    (chip) => !(chip.query === chipToRemove.query && chip.type === chipToRemove.type)
  );
  setSearchChips(updatedChips);
  sessionStorage.setItem('itemsSearchChips', JSON.stringify(updatedChips)); // <-- Use unique key

  if (updatedChips.length === 0) {
    setFilteredItems(Items);
    setPersistedSearchQuery('');
    setPersistedSearchType('');
    return;
  }

  const last = updatedChips[updatedChips.length - 1];
  handleSearch(last.query, last.type);
};


const handleAddSearchChip = (query, type) => {
  if (!type) return;

  // Store the actual query, which can be an empty string if no text was entered
  const actualQuery = query.trim(); 

  setSearchChips((prev) => {
    // Check for existence based on actual query and type
    const exists = prev.some((chip) => chip.query === actualQuery && chip.type === type);
    if (exists) return prev;

    // Store the actual query and type
    const updated = [...prev, { query: actualQuery, type }]; 
    sessionStorage.setItem('itemsSearchChips', JSON.stringify(updated)); 
    return updated;
  });

  // These lines are crucial for the highlighting to work when a new chip is added
  setPersistedSearchQuery(actualQuery); // Update persisted query to reflect the new search
  setPersistedSearchType(type);         // Update persisted type to reflect the new search

  // Also, ensure the search is applied immediately after adding the chip
  handleSearch(actualQuery, type);
};
const handleChipClick = (chip) => {
  // Update the search bar's state to reflect the clicked chip
  setPersistedSearchType(chip.type);
  setPersistedSearchQuery(chip.query);
  // Apply the filter based on the clicked chip's query and type
  handleSearch(chip.query, chip.type);
};

  const fetchRoleId = () => {
    const encryptedroleId = sessionStorage.getItem('roleId');
    const sroleId = decryptData(encryptedroleId);
    setRoleId(sroleId);
  };

  const fetchItems = async (attempt = 1) => {
    try {
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);
              const encryptedOrganizationId = sessionStorage.getItem('organizationId');
              const organizationId = decryptData(encryptedOrganizationId);
      const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET + `product/get-all-products?organizationId=${organizationId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      const data = await response.json();
      if (data.status === 200 || data.status === 201 || data.status === 204) {
        setItems(data.data);
        
        console.log(data.data)
      } else if (data.status === 400) {
        setShowPopup(true);
        setPopupType('400');
        setPopupMessage('Bad Request!');
      } else if (data.status === 401) {
        setShowPopup(true);
        setPopupType('401');
        setPopupMessage('Unauthorized!');
      } else if (data.status === 403) {
        setShowPopup(true);
        setPopupType('403');
        setPopupMessage('Forbidden!');
      } else if (data.status === 404) {
        setShowPopup(true);
        setPopupType('404');
        setPopupMessage('Not Found!');
      } else if (data.status === 500) {
        setShowPopup(true);
        setPopupType('500');
        setPopupMessage('Internal Server Error!');
      } else {
        setShowPopup(true);
        setPopupType('unknown');
        setPopupMessage('Unknown error!');
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
  
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => fetchItems(attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchItems(attempt)); // Set retry function
      }
    }finally {
      setIsLoading(false);
    }
  };

  const handleOpenToggle = (e) => {
    // Stop event propagation to prevent immediate closing
    e.stopPropagation();
    setShowOpen(prevState => !prevState);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOpen(false);
      }
    };

    // Add event listener when component mounts
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup event listener when component unmounts
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []); // Empty dependency array ensures this runs once on mount

if (isLoading) {
  return <Loader />;
}

const handleCheckboxChange = (item) => {
  if (selectedItems.includes(item)) {
    setSelectedItems(selectedItems.filter((i) => i !== item));
    setSelectAll(false); // Update selectAll state when deselecting a checkbox
  } else {
    setSelectedItems([...selectedItems, item]);
    if (selectedItems.length === Items.length - 1) {
      setSelectAll(true); // Update selectAll state when selecting all checkboxes
    }
  }
};

const handleSelectAll = () => {
  if (selectAll) {
    setSelectedItems([]);
    setSelectAll(false);
  } else {
    setSelectedItems(Items);
    setSelectAll(true);
  }
};

const handleDelete = async (attempt = 1) => {
  const selectedItemIds = selectedItems.map((item) => item._id);
  console.log(selectedItemIds);
  try {
        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);

    const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET + "item/delete-items", {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
      body: JSON.stringify({ ItemIds: selectedItemIds })
    });

    const data = await response.json();
    if (data.status === 200 || data.status === 201 || data.status === 204) {
      // Update the vendors state to reflect the deleted vendors
      setItems(Items.filter((item) => !selectedItemIds.includes(item._id)));
      setSelectedItems([]);
      setSelectAll(false);
    } else {
      // Handle error cases
      setPopupMessage(data.message);
      setPopupType(`${data.status}`);
      setShowPopup(true);
    }
  }catch (error) {
    console.error('Failed to fetch:', error);

    if (attempt < RETRY_LIMIT) {
      setRetryCount(attempt + 1); // Increment retry count
      setTimeout(() => handleDelete(attempt + 1), 1000); // Retry after 1 second
    } else {
      setIsLoading(false);
      setPopupMessage('Internal Server Error. Kindly Retry.');
      setPopupType('500');
      setShowPopup(true);
      setRetryFunction(() => () => handleDelete(attempt)); // Set retry function
    }
  }
};

const handleCreate = () => {
  navigate("/bb/app/items/newitem");
};
 const handleNavigateItemDetails = (item) =>{
  navigate("/bb/app/items/itemdetails", {state:{ItemData:item}})
 }

 const closePopup = () => {
  console.log("closePopup called");
  setShowPopup(false);
};



const BackToLoginPage = () => {
  console.log("Back To Login Page");
  setShowPopup(false);
  localStorage.removeItem('LoginData');
  sessionStorage.removeItem('userData');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('userId');
  sessionStorage.removeItem('appId');
navigate('/bb');
};


const handleExport = () => {
  // Handle export items
  setshowExportItemPopup(true);
};

const handleImport = () => {
  // Handle import items
  navigate('/bb/app/items/bulkuploaditems')
};

const handleClosePopup = () => {
  setshowExportItemPopup(false);
};

const handleFormatChange = (event) => {
  setSelectedFormat(event.target.value);
};

const handleSaveExport = async () => {
  try {
       const encryptedToken = sessionStorage.getItem('token');
           const token = decryptData(encryptedToken);
          
    // Prepare request payload
    const payload = {
      selectedHeaders: setHeaders.join(','), // Convert array to comma-separated string
      fileType: selectedFormat.toLowerCase(),
    };

    console.log(payload)
    // Make API call to export products data
    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product/export-products`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error('Export failed');
    }

    // Get the blob from response
    const blob = await response.blob();
    
    // Create download link
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = `items_export.${selectedFormat.toLowerCase()}`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);

    // Close popup
    setshowExportItemPopup(false);
    
    // Show success message
    setPopupMessage('Items exported successfully!');
    setPopupType('200');
    setShowPopup(true);

    // Auto-close popup after 2 seconds
    setTimeout(() => {
      setShowPopup(false);
    }, 2000);
    
  } catch (error) {
    console.error('Export error:', error);
    setPopupMessage('Failed to export items. Please try again.');
    setPopupType('500');
    setShowPopup(true);
  }
};

const handleHeaderChange = (header) => {
  if (setHeaders.includes(header)) {
    setSetHeaders(setHeaders.filter(h => h !== header));
  } else {
    setSetHeaders([...setHeaders, header]);
  }
};

const handleCloseAddNewPopup = () => {
  setShowAddNewPopup(false);
};

const handleSingleItemCreate = () => {
  navigate("/bb/app/items/newitem");
  setShowAddNewPopup(false);
};

const handleBulkItemCreate = () => {
  navigate("/bb/app/items/bulkuploaditems");
  setShowAddNewPopup(false);
};

// Pagination logic
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

// Pagination handlers
const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};

const handlePreviousPage = () => {
  if (currentPage > 1) {
    setCurrentPage(currentPage - 1);
  }
};

const handleNextPage = () => {
  if (currentPage < totalPages) {
    setCurrentPage(currentPage + 1);
  }
};

// Generate page numbers for pagination
const getPageNumbers = () => {
  const pageNumbers = [];
  const maxVisiblePages = 5;
  
  if (totalPages <= maxVisiblePages) {
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
  } else {
    if (currentPage <= 3) {
      for (let i = 1; i <= 4; i++) {
        pageNumbers.push(i);
      }
      pageNumbers.push('...');
      pageNumbers.push(totalPages);
    } else if (currentPage >= totalPages - 2) {
      pageNumbers.push(1);
      pageNumbers.push('...');
      for (let i = totalPages - 3; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      pageNumbers.push(1);
      pageNumbers.push('...');
      for (let i = currentPage - 1; i <= currentPage + 1; i++) {
        pageNumbers.push(i);
      }
      pageNumbers.push('...');
      pageNumbers.push(totalPages);
    }
  }
  
  return pageNumbers;
};

return (
  <div className="flex flex-col h-full bg-white">
    {/* Fixed Header */}
    <div className="flex-shrink-0 bg-white border-b shadow-sm">
      {/* Top Header with Title and Actions */}
      <div className="p-2 border-b flex flex-row justify-between items-center">
     <div className="space-x-6 flex items-center gap-4 p-2">
  {/* All Items Title */}
  <h5 className="text-lg font-bold whitespace-nowrap">All Items</h5>

  {/* Search Bar just beside it with gap */}
  <div className="w-full max-w-md">
    <Search
      searchQuery={persistedSearchQuery}
      setSearchQuery={setPersistedSearchQuery}
      searchType={persistedSearchType}
      setSearchType={setPersistedSearchType}
      searchTypes={searchTypes}
      onSearch={handleSearch}
      onSearchSubmit={handleAddSearchChip}
      placeholder="Search items..."
    />
  </div>


      
{/* Show all search chips */}
{searchChips.length > 0 && (
  <div className="w-full flex flex-cols gap-3 items-center mt-2 px-4">
    {searchChips.map((chip, index) => {
      const isActive = chip.type === persistedSearchType;

      const chipClasses = `flex items-center max-w-xs text-sm px-3 py-1 rounded-full shadow-sm transition-all duration-150 ${
        isActive
          ? 'bg-red-500 text-white'
          : 'bg-gray-100 text-gray-800'
      }`;

      return (
        <div
          key={`${chip.type}-${index}`}
          className={chipClasses}
          style={{ whiteSpace: 'nowrap' }}
          onClick={() => handleChipClick(chip)}
        >
          <span className="whitespace-nowrap max-w-[130px]">
            {chip.query ? chip.query : chip.type}
          </span>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveSearchChip(chip);
            }}
            className={`ml-2 text-base font-bold ${
              isActive ? 'text-white hover:text-gray-200' : 'text-gray-500 hover:text-red-500'
            }`}
          >
            ×
          </button>
        </div>
      );
    })}
  </div>
)}








        </div>

        <div className='flex gap-3 items-center'>
          

          {selectedItems.length > 0 && (
            <button
              className="bg-red-500 py-2 px-3 text-white text-sm rounded-md hover:bg-red-600 transition-colors"
              onClick={handleDelete}
            >
              Delete ({selectedItems.length})
            </button>
          )}

          <div className="relative" ref={dropdownRef}>
            <button
              className="bg-[#f7525a] py-2 px-3 text-white text-sm rounded-md hover:bg-green-700 transition-colors"
              onClick={handleOpenToggle}
            >
              <FontAwesomeIcon icon={faEllipsisV} className="text-white cursor-pointer" />
            </button>

            {showOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-20 border border-gray-200">
                <div className="py-1">
                  <button
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={handleExport}
                  >
                    Export Items
                  </button>
                  <button
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={handleImport}
                  >
                    Import Items
                  </button>
                </div>
              </div>
            )}
          </div>

          <button
            className="bg-[#f7525a] py-2 px-3 text-white text-sm rounded-md hover:bg-green-700 transition-colors"
            onClick={() => setShowAddNewPopup(true)}
          >
            <FontAwesomeIcon icon={faPlus} className="text-white mr-1" />
            Add Item
          </button>
        </div>
      </div>

      {/* Items Count and Pagination Info */}
      <div className="px-2 py-2 bg-white border-b flex justify-between items-center text-sm text-gray-600">
        <div className="font-medium">
          Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredItems.length)} of {filteredItems.length} items
        </div>
        <div className="font-medium">
          Page {currentPage} of {totalPages}
        </div>
      </div>

      {/* Fixed Table Header */}
      <div className="bg-white ">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[1200px]">
            <thead className="bg-[#fafafc] text-[#6c7184] uppercase text-xs">
              <tr className="">
                <th className="p-1 py-2 text-sm font-semibold w-12 text-center">
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                    className="border border-gray-400 shadow-sm hover:shadow-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-600 rounded"
                  />
                </th>
{/*                 <th className="p-3 text-sm font-semibold w-16 text-center">S.No</th>
 */}                <th className="p-1 pl-1  w-20 text-left">Item Image</th>
                <th className="p-1 pl-12  w-50 cursor-pointer text-center hover:bg-gray-100" onClick={() => sortArray('product_name')}>
                  <div className="flex items-center justify-between">
                    Item Name
                    {getSortIcon('product_name') && <FontAwesomeIcon icon={getSortIcon('product_name')} className="ml-1 text-gray-400" />}
                  </div>
                </th>
                <th className="p-1 cursor-pointer w-32 text-center hover:bg-gray-100" onClick={() => sortArray('SKU')}>
                  <div className="flex items-center justify-center">
                    SKU
                    {getSortIcon('SKU') && <FontAwesomeIcon icon={getSortIcon('SKU')} className="ml-1 text-gray-400" />}
                  </div>
                </th>
                 <th className="p-1 cursor-pointer w-32 text-center hover:bg-gray-100" onClick={() => sortArray('cost_price')}>
                  <div className="flex items-center justify-center">
                    Cost Price
                    {getSortIcon('cost_price') && <FontAwesomeIcon icon={getSortIcon('cost_price')} className="ml-1 text-gray-400" />}
                  </div>
                </th>
                <th className="p-1  cursor-pointer w-32 text-center hover:bg-gray-100" onClick={() => sortArray('selling_price')}>
                  <div className="flex items-center justify-center">
                    Selling Price
                    {getSortIcon('selling_price') && <FontAwesomeIcon icon={getSortIcon('selling_price')} className="ml-1 text-gray-400" />}
                  </div>
                </th>
                <th className="p-1  cursor-pointer w-40 text-center hover:bg-gray-100" onClick={() => sortArray('vendor_id.name')}>
                  <div className="flex items-center justify-center">
                    Vendor
                    {getSortIcon('vendor_id.name') && <FontAwesomeIcon icon={getSortIcon('vendor_id.name')} className="ml-1 text-gray-400" />}
                  </div>
                </th>
                <th className="p-1  cursor-pointer w-40 text-center hover:bg-gray-100" onClick={() => sortArray('product_category_id.product_category_name')}>
                  <div className="flex items-center justify-center">
                    Category
                    {getSortIcon('product_category_id.product_category_name') && <FontAwesomeIcon icon={getSortIcon('product_category_id.product_category_name')} className="ml-1 text-gray-400" />}
                  </div>
                </th>
                <th className="p-1   cursor-pointer w-40 text-center hover:bg-gray-100" onClick={() => sortArray('product_category_id.product_category_name')}>
                  <div className="flex items-center justify-center">
                    Sub Category
                    {getSortIcon('product_sub_category_id.product_sub_category_name') && <FontAwesomeIcon icon={getSortIcon('product_category_id.product_category_name')} className="ml-1 text-gray-400" />}
                  </div>
                </th>
                <th className="p-1  cursor-pointer w-40 text-center hover:bg-gray-100" onClick={() => sortArray('product_group_id.product_group_name')}>
                  <div className="flex items-center justify-center">
                    Group
                    {getSortIcon('product_group_id.product_group_name') && <FontAwesomeIcon icon={getSortIcon('product_group_id.product_group_name')} className="ml-1 text-gray-400" />}
                  </div>
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>

    {/* Scrollable Table Body */}
    <div className="flex-1 overflow-y-auto overflow-x-auto">
      <table className="w-full min-w-[1200px]">
        <tbody>
          {currentItems.length > 0 ? (
            currentItems.map((item, index) => (
              <tr key={item._id} className={`border-b hover:bg-gray-50 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-25'}`}>
                <td className="p-1 text-sm w-12 text-center">
                  <input
                    type="checkbox"
                    checked={selectedItems.includes(item)}
                    onChange={() => handleCheckboxChange(item)}
                    className="border border-gray-400 shadow-sm hover:shadow-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-600 rounded"
                  />
                </td>
{/*                 <td className="p-3 text-sm border-r w-16 text-center font-medium text-gray-600">
                  {indexOfFirstItem + index + 1}
                </td> */}
               <td className="p-1 text-sm w-20 text-left"> {/* Changed text-center to text-left */}
  {item.product_image && item.product_image.length > 0 ? (
    <img
      src={`${imageUrl}${item.product_image}`}
      alt={item.product_name}
      /* Removed mx-auto, added ml-2 */
      className="w-10 h-10 object-cover rounded ml-2 cursor-pointer border border-gray-200"
      onClick={() => handleNavigateItemDetails(item)}
    />
  ) : (
    /* Removed mx-auto, added ml-2 */
    <div className="w-10 h-10 p-1 leading-tight bg-gray-100 rounded ml-2 flex items-center justify-center border border-gray-200">
      <span className="text-gray-400 text-[10px] text-center cursor-pointer" onClick={() => handleNavigateItemDetails(item)}>
        No Image
      </span>
    </div>
  )}
</td>
                <td className="p-1 text-sm cursor-pointer w-50 text-[#408dfb] font-500  hover:underline" onClick={() => handleNavigateItemDetails(item)}>
                  {item.product_name}
                </td>
                <td className="p-1 text-sm w-32 text-center">
                  {item.SKU || 'N/A'}
                </td>
                 <td className="p-1 text-sm w-32 text-center font-medium text-orange-600">
                  ₹{item.cost_price ? parseFloat(item.cost_price).toLocaleString() : '0'}
                </td>
                <td className="p-1 text-sm w-32 text-center font-medium text-green-600">
                  ₹{item.selling_price ? parseFloat(item.selling_price).toLocaleString() : '0'}
                </td>
                <td className="p-1 text-sm w-40 text-center">
                  {item.vendor_id?.name || 'N/A'}
                </td>
                <td className="p-1 text-sm w-40 text-center">
                  {item.product_category_id?.product_category_name || 'N/A'}
                </td>
                <td className="p-1 text-sm w-40 text-center">
                  {item.product_sub_category_id?.product_sub_category_name || 'N/A'}
                </td>
                <td className="p-1 text-sm w-40 text-center">
                  {item.product_group_id?.product_group_name || 'N/A'}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="10" className="p-12 text-center text-gray-500 border-b border-gray-200">
                <div className="flex flex-col items-center">
                  <FontAwesomeIcon icon={faSearch} className="text-4xl text-gray-300 mb-4" />
                  <p className="text-lg font-medium mb-2">No items found</p>
                  <p className="text-sm">Try adjusting your search criteria or add new items</p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>

    {/* Fixed Pagination Footer */}
    {totalPages > 1 && (
      <div className="flex-shrink-0 bg-white border-t shadow-sm">
        <div className="flex justify-between items-center p-2">
          <div className="flex items-center space-x-2">
            <button
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
              className="px-4 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white transition-colors"
            >
              Previous
            </button>
            
            <div className="flex space-x-1">
              {getPageNumbers().map((pageNumber, index) => (
                <button
                  key={index}
                  onClick={() => typeof pageNumber === 'number' && handlePageChange(pageNumber)}
                  disabled={pageNumber === '...'}
                  className={`px-3 py-2 text-sm border rounded-md transition-colors ${
                    pageNumber === currentPage
                      ? 'bg-blue-500 text-white border-blue-500 shadow-sm'
                      : pageNumber === '...'
                      ? 'cursor-default border-gray-300 text-gray-400'
                      : 'border-gray-300 hover:bg-gray-50 text-gray-700'
                  }`}
                >
                  {pageNumber}
                </button>
              ))}
            </div>
            
            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              className="px-4 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white transition-colors"
            >
              Next
            </button>
          </div>
          
          <div className="text-sm text-gray-600 font-medium">
            Total: {filteredItems.length} items
          </div>
        </div>
      </div>
    )}

    {/* Export Popup */}
      {showExportItemPopup && (
  <div className="fixed z-20 inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50">
    <div className="bg-white rounded-b-md shadow-md w-1/2 h-2/3 flex flex-col ">
      <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-[10%] px-6'>
        <h2 className="text-md">Export</h2>
        <button  onClick={handleClosePopup}  className="text-white px-1 py-1 rounded-md ">   
          <FontAwesomeIcon icon={faX} className="text-xs text-[#e54643] cursor-pointer " />
        </button>
      </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      {errorMessages.length > 0 && (
        <div className='p-1'>
                <div className="mt-1 flex justify-between items-center  px-auto py-1  bg-[#fddcde]  rounded-md">
                  <div className="px-6 flex flex-col justify-start items-start">
                    {/* {errorMessages.map((errorMessage, index) => (
                      <span key={index} className="text-sm">
                         •   {errorMessage}
                      </span>
                    ))} */}
                  </div>
                  <div className='px-4'>
                  <button
                    className="text-gray-700 hover:text-red-500"
                   // onClick={handleCloseError}
                  >
                    <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A] cursor-pointer" />
                  </button>
                  </div>
                </div>
                </div>
              )}

<div className="px-6 py-4">
  <div className='w-full flex flex-col items-start  space-x-2 px-6'>
  <label htmlFor="exportfile" className="block text-sm font-regular text-gray-700 ">
  Fields in Export File
  
        </label>
        <Select
  isMulti
  value={selectedHeadersForExport}
  onChange={(selectedOptions) => {
    setSelectedHeadersForExport(selectedOptions);
    const headers = selectedOptions.map((option) => option.value);
    setSetHeaders(headers);
  }}
  options={dropdownOptions}
  className="w-full"
/>
    

        </div>
<div className="w-full flex flex-col items-start  space-x-2 px-6 mt-2">
<label htmlFor="exportas" className="block text-sm font-regular text-[#e54643] w-1/6">
          Export As<span className="text-red-500">*</span>
        </label>
              <div className="flex flex-col space-y-2 mt-2">
                <label className="flex items-center">
                  <input type="radio" value="CSV" checked={selectedFormat === 'CSV'} onChange={handleFormatChange} className="form-radio" />
                  <span className="ml-2">CSV (Comma Separated Value)</span>
                </label>
                <label className="flex items-center">
                  <input type="radio" value="XLSX" checked={selectedFormat === 'XLSX'} onChange={handleFormatChange} className="form-radio" />
                  <span className="ml-2">XLSX (Microsoft Excel)</span>
                </label>
              </div>
              </div>
              </div>
     
      <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
          <button className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md"
            onClick={handleSaveExport}  >
            Export {/* {isSaving && <Spinner />} */}
            </button>
          <button  onClick={handleClosePopup} className="px-2 py-1 bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD] rounded-md">Cancel</button>
        </div>
      </div>
    </div>
  </div>
)}

    {/* Add New Item Popup */}
    {showAddNewPopup && (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
        <div className="bg-white rounded-lg shadow-xl w-96">
          <div className="flex justify-between items-center p-4 border-b bg-gray-50">
            <h2 className="text-lg font-semibold text-gray-800">Add New Item</h2>
            <button onClick={handleCloseAddNewPopup} className="text-gray-500 hover:text-gray-700 transition-colors">
              <FontAwesomeIcon icon={faX} />
            </button>
          </div>
          
          <div className="p-4">
            <div className="space-y-3">
              <button
                onClick={handleSingleItemCreate}
                className="w-full p-4 text-left border border-gray-300 rounded-md hover:bg-gray-50 hover:border-gray-400 flex items-center transition-colors"
              >
                <FontAwesomeIcon icon={faPlus} className="mr-3 text-blue-600" />
                <div>
                  <div className="font-medium text-gray-800">Single Item</div>
                  <div className="text-sm text-gray-500">Create one item at a time</div>
                </div>
              </button>
              
              <button
                onClick={handleBulkItemCreate}
                className="w-full p-4 text-left border border-gray-300 rounded-md hover:bg-gray-50 hover:border-gray-400 flex items-center transition-colors"
              >
                <FontAwesomeIcon icon={faPlusCircle} className="mr-3 text-green-600" />
                <div>
                  <div className="font-medium text-gray-800">Bulk Upload</div>
                  <div className="text-sm text-gray-500">Upload multiple items via CSV/Excel</div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    )}

    {/* Message Popups */}
    {showPopup && popupType === '200' && (
      <Msg200or201 
        message={popupMessage} 
        onClose={closePopup} 
      />
    )}
    {showPopup && popupType === '201' && (
      <Msg200or201 
        message={popupMessage} 
        onClose={closePopup} 
      />
    )}
    {showPopup && popupType === '204' && (
      <Msg204 
        message={popupMessage} 
        onClose={closePopup} 
      />
    )}
    {showPopup && popupType === '400' && (
      <Msg400 
        message={popupMessage} 
        onClose={closePopup} 
      />
    )}
    {showPopup && popupType === '401' && (
      <Msg401 
        message={popupMessage} 
        onClose={closePopup} 
        onBackToLogin={BackToLoginPage} 
      />
    )}
    {showPopup && popupType === '403' && (
      <Msg403 
        message={popupMessage} 
        onClose={closePopup} 
      />
    )}
    {showPopup && popupType === '500' && (
      <Msg500 
        message={popupMessage} 
        onClose={closePopup} 
        onRetry={retryFunction} 
      />
    )}
  </div>
);
};

export default AllItems;
